import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58de0be0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de0be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/shenyang-xcommunity-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58de0be0')) {
      api.createRecord('58de0be0', component.options)
    } else {
      api.reload('58de0be0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58de0be0&scoped=true", function () {
      api.rerender('58de0be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYPOISearch/index.vue"
export default component.exports